import { Component, input } from '@angular/core';
import { TooltipConfig } from '@shared/core/interfaces/tooltip-config.interface';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-tooltip',
  standalone: true,
  imports: [TooltipModule],
  templateUrl: './tooltip.component.html',
  styleUrl: './tooltip.component.scss',
})
export class TooltipComponent {
  text = input.required<string>();

  config = input<TooltipConfig>();

  icon = input<string>('pi-question-circle');

  fontSize = input<string>();

  iconClasses = `pi ${this.icon()}`;
}
